export default __webpack_public_path__ + "images/gamification-manual-trail.png";